'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var moment = _interopDefault(require('moment-timezone'));

var isDateValid = function (date) {
    if (!date) {
        return true;
    }
    // for the moment excluding anything that results in an exception when you convert to string
    return date.isValid();
};
var getCustomDateRange = function (selectState, startDate, endDate) {
    var start;
    var end;
    switch (selectState) {
        case '+7':
            start = moment();
            end = moment().add(7, 'd');
            break;
        case '+14':
            start = moment();
            end = moment().add(14, 'd');
            break;
        case '+30':
            start = moment();
            end = moment().add(30, 'd');
            break;
        case 'custom':
            start = startDate || (startDate === null ? null : moment());
            end = endDate || (endDate === null ? null : moment());
            break;
        case 'allDates':
            start = null;
            end = null;
            break;
        case 'lastWeek':
            start = moment()
                .startOf('isoWeek') // <- Monday
                .subtract(1, 'week');
            end = moment().startOf('week'); // <- Sunday
            break;
        case 'lastMonth':
            start = moment()
                .subtract(1, 'month')
                .startOf('month');
            end = moment()
                .subtract(1, 'month')
                .endOf('month');
            break;
        case 'lastYear':
            start = moment()
                .subtract(1, 'year')
                .startOf('year');
            end = moment()
                .subtract(1, 'year')
                .endOf('year');
            break;
        case 'thisWeek':
            start = moment().startOf('isoWeek');
            end = moment().endOf('isoWeek');
            break;
        case 'thisMonth':
            start = moment().startOf('month');
            end = moment();
            break;
        case 'thisYear':
            start = moment().startOf('year');
            end = moment();
            break;
        case 'nextWeek':
            start = moment()
                .startOf('isoWeek') // <- Monday
                .add(1, 'week');
            end = moment()
                .add(1, 'week')
                .endOf('isoWeek'); // <- Sunday
            break;
        case 'nextMonth':
            start = moment()
                .add(1, 'month')
                .startOf('month');
            end = moment()
                .add(1, 'month')
                .endOf('month');
            break;
        case 'reactivation':
            start = null;
            end = moment().subtract(18, 'month');
            break;
        default:
            start = moment().subtract(parseInt(selectState, 10), 'd');
            end = moment();
            break;
    }
    // exclude moment values that are `Invalid Date`, prevents exceptions down the line
    if (!isDateValid(start) || !isDateValid(end)) {
        return undefined;
    }
    return { start: start, end: end };
};

exports.getCustomDateRange = getCustomDateRange;
exports.isDateValid = isDateValid;
